import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_baby_shower_gifts: FaireThemeEntity = {
  token: "discovery_theme_baby-shower-gifts",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Baby Shower Gifts",
  description: "Sweet and practical gifts for new parents",
  bgColor: "#F0E8F5",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
